import { useState } from "react";
import { authService } from "../services/auth";

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (phone, password) => {
    try {
      setLoading(true);
      setError(null);
      const user = await authService.login(phone, password);
      return user;
    } catch (err) {
      setError(err.message || "Giriş işlemi başarısız oldu");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const register = async (userData) => {
    try {
      setLoading(true);
      setError(null);
      const result = await authService.register(userData);
      return result;
    } catch (err) {
      setError(err.message || "Kayıt işlemi başarısız oldu");
      console.error("Kayıt hatası:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    authService.logout();
  };

  const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    const isAuth = !!token;
    return isAuth;
  };

  return {
    login,
    register,
    logout,
    isAuthenticated,
    loading,
    error,
  };
};

export default useAuth;
